<template>
    <div>
        <e-dialog
                dialog-title="查看详情"
                :center-dialog-visible="availableVisible"
                popup-width="600px"
                :showCloseBtn="true"
                :showBtn="false"
                @resetPopupData="handleClose">
            <el-form ref="formName" label-width="150px">
                <el-form-item label="原材料供应商名称：">{{materialSupplierCompanyName}}</el-form-item>
                <el-form-item label="附件：">
                    <div class="attach-box" v-for="(item,fileIndex) in attachList" :key="fileIndex">
                        <div class="attach-left">
                            <a target="_blank" :href="item.url">
                                <eui-tooltip-over :tooltipStyle="{ 'width': '200px' }" class="file-name"
                                                  :content="item.name">
                                    <span>{{item.name}}</span>
                                </eui-tooltip-over>
                            </a>
                            <div class="margin-t4">
                                <div class="label-item" v-if="item.tags">{{item.tags}}</div>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="备注：">{{remark}}</el-form-item>
            </el-form>
        </e-dialog>
    </div>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog.vue';
import api from '@/modules/projectA/api/order';

export default {
  name: "availableDialog",
  components: {
    eDialog
  },
  props: {
    availableVisible: Boolean,
    petroMallOrderId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      attachList: [],
      materialSupplierCompanyName: '',
      remark: ''
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:availableVisible', false);
    },
    //是现货，查看已关联的供应商及附件
    async mallOrderMaterialSupplierList() {
      const {code, data} = await api.mallOrderMaterialSupplierList({id: this.petroMallOrderId});
      if (code === '200' && data.length > 0) {
        this.attachList = data[0].attachList || [];
        this.materialSupplierCompanyName = data[0].materialSupplierCompanyName || '';
        this.remark = data[0].remark || '';
      }
    },
  },
  mounted() {
    this.mallOrderMaterialSupplierList();
  }
}
</script>

<style scoped lang="scss">
.attach-box {
    width: 300px;
    height: 60px;
    padding: 6px 10px 10px 10px;
    background: linear-gradient(90deg, #F5F5F5 0%, rgba(245, 245, 245, 0.20) 100%);
    margin-bottom: 10px;

    .attach-left {
        .margin-t4 {
            margin-top: 4px;
        }

        .label-item {
            width: 64px;
            height: 20px;
            line-height: 20px;
            border: 1px solid #D9D9D9;
            margin-right: 6px;
            color: #666;
            text-align: center;
            font-size: 12px;
            cursor: pointer;
            background-color: #fff;

            &:hover {
                background-color: #e9f3ff;
                border-color: #2587FF;
                color: #2587FF;
            }
        }
    }

    .file-name {
        color: #0064C8;
        cursor: pointer;
        margin-top: -8px;
    }
}
</style>